module ProcessEditor {
    "use strict";

    app.directive("frendsTaskSelector", () => {
        return {
            restrict: "EA",
            scope: true,
            bindToController: {taskNode: "="},
            templateUrl: "taskSelectorDirectiveTemplate.htm",
            controller: "taskSelectorController as ctrl"
        };
    });

    class TaskSelectorController {
        public taskNode: TaskNode;
        public availableTasks: ITaskSelectionData[];
        public availablePackages: string[];

        static $inject = ["TaskService", "PopoverService"];
        constructor(public taskService: TaskService, private popoverService: PopoverService) {
            this.taskService.getAvailableTasks().then((tasks) => {
                this.availableTasks = tasks;
                this.availablePackages = _.chain(tasks).map(m=> m.packageName).uniq().value();
            });
        }

        // ui-select's group-by attribute requires a function, which takes an iteration object as a parameter
        public groupTasksBy(task: ITaskSelectionData) {
            return task.packageName;
        }

        // Friendly(er) name for tasks, so the dropdown doesnt show package name for each task
        public getTaskLabel(taskName: string) {
            if (!taskName) { return ""; }
            let taskNameParts = taskName.split(".");
            return taskNameParts.splice(taskNameParts.length - 2).join(".");
        }

        // Hovering over the dropdown list shows a little more detail about selected task
        public getTaskTitle(task: ITaskSelectionData) {
            let taskName = task ? task.name : this.taskNode.taskName;
            let packageName = task ? task.packageName : this.taskNode.packageName;
            let description = task ? task.description : this.taskNode.description;
            let returnType = task ? task.returnType : this.taskNode.returnType;

            var title = `${FRENDS.Localizations.Task}: ${taskName}\n`;
            if (packageName) {
                title += `${FRENDS.Localizations.Task_Package}: ${packageName}\n`;
            }
            if (description) {
                title += `${FRENDS.Localizations.Description}: ${description}\n`;
            }
            title += `${FRENDS.Localizations.Return} ${FRENDS.Localizations.Type}: ${returnType}`;

            return title;
        }

        // Callback, fired by ui-select on change
        public changeTask(selectedTask: ITaskSelectionData) {
            this.taskNode.taskUri = selectedTask.uri;
            this.taskNode.taskName = selectedTask.name;
            this.taskNode.packageName = selectedTask.packageName;
            this.taskNode.returnType = selectedTask.returnType;
            this.taskNode.description = selectedTask.description;
            this.taskNode.parameters = this.taskService.getTaskParameters(selectedTask.arguments, this.taskNode.parameters);

            // Re-renders the popover to position it correctly after the content chagnes.
            // setTimeout ensures the popover re-render happens after angular is done rendering the contents.
            setTimeout(() => {
                this.popoverService.reopenPopover(this.taskNode.nodeId);
            }, 0);
        }
    }
    app.controller("taskSelectorController", TaskSelectorController);
}